// extracted by mini-css-extract-plugin
export default {"reqFieldsLabel":"src-feature-marketplace-automation-__automation_reqFieldsLabel","mappingFieldItem":"src-feature-marketplace-automation-__automation_mappingFieldItem"};